define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/comm",
	"csi/config",
	"csi/html",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml",
	"csi/action/Controller"
], function(array,declare,lang,csi,comm,config,html,locale,MessageDialog,xml,Controller) {

	var PATH_SPEC = "Child:__Parent__/Child:__Parent__/Child:Spec";
	
	return declare(null, {
		onRefreshValidation: function() {
			// summary: extension point to refresh view when validation fails
		},

		hasToConfirmAction: function() {
			// see if the BOM has the Validate flag set
			return !this.m_cache.getNode(this.getParent().__Parent__).$Type == "Theme" && (this.getParent().Subtype == csi.EMPTY_URL || config.getSubtypeSetting(this.getParent().Subtype, "ValidateBOM"));
		},

		confirmAction: function(/*Object*/params) {
			// summary: invoke call to validate product structure and confirm if invalid
			this.m_writer.callMethod("Specification", "BOMValidate")
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode);

			this.m_writer.execute({
				load: lang.hitch(this, this._onValidateResponse),
				error: lang.hitch(this, this._onPublishError)
			});
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CONTINUE) {
				this.preProcess();
			} else {
				this.postProcess();
				this.onRefreshValidation();
			}
		},

		onDependencyPaths: function(paths) {
			paths.push(PATH_SPEC);
			this.inherited(arguments);
		},

		_onValidateResponse: function(/*Response*/response) {
			this.m_cache.cacheResponse(response);

			var status = xml.enumGetText(this.getNode().ValidationStatus);
			if (status == "Valid") {
				// structure is valid, so no reason to confirm
				this.preProcess();
			} else {
				// structure is invalid, so confirm that action should still be performed
				var invalidBOMLines = this._gatherInvalidBOMLines(response.getNodes());
				var allBOMLineURLs = this.m_cache.getNode(this.m_urlNode).Items;

				var	s = "";
				array.forEach(allBOMLineURLs, function(bomLineURL) {
					var invalidBOMLine = invalidBOMLines[bomLineURL];
					if (invalidBOMLine != null) {
						s += html.TAB;
						s += (invalidBOMLine.$Name == "" ? locale.resource("NAME_EMPTY") : invalidBOMLine.$Name);
						if (invalidBOMLine.PSPlacement != csi.EMPTY_URL)
							s += " (" + locale.type("ProductStructure") + ")";
						s += "\n";
					}
				});

				// see if there is a product structure but no tool
				var psNode = this.m_cache.getPathNode(this.getNode(), PATH_SPEC);
				if (xml.isValidURL(psNode.ProductStructure) && !xml.isValidURL(psNode.Tool)) {
					s += locale.resource("ProductStructureToolMissing") + "\n";
				}

				this._confirm("MaterialUnavailableTitle", "MaterialUnavailablePrompt", s);
			}
		},

		_gatherInvalidBOMLines: function(responseNodes) {
			var invalidLines = {};
			array.forEach(responseNodes, function(node) {
				if (node.$Type == "PartMaterial") {
					var	v = xml.enumGetText(node.ValidationStatus);
					if ((v && (v != "Valid")) || !xml.isValidURL(node.Actual)) {
						invalidLines[node.$URL] = node;
					}
				}
			});
			return invalidLines;
		},

		_confirm: function(titleKey, messageKey, bomLineNames) {
			Controller.prototype.confirmAction.call(this, {
				materialIcon: MessageDialog.ICON_WARNING,
				title: locale.resource(titleKey),
				buttons: [MessageDialog.BUTTON_CONTINUE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
				message: locale.resource(messageKey, [bomLineNames])
			});
		}
	});
});